var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40969",
    "data-name": "Group 40969",
    transform: "translate(-789 -358)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6000",
    "data-name": "Ellipse 6000",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(789 358)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo",
    d: "M7.791,5.665,12.664,0H11.509L7.278,4.919,3.9,0H0L5.111,7.438,0,13.379H1.155L5.624,8.184l3.569,5.194h3.9l-5.3-7.714ZM6.209,7.5l-.518-.741L1.571.869H3.345L6.67,5.626l.518.741,4.322,6.182H9.736L6.209,7.5Z",
    transform: "translate(794.56 363.231)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.ca5ac63e493925f0729bfb2359117851.svg";
export { ForwardRef as ReactComponent };